




























































import {Component, Mixins, Ref} from 'vue-property-decorator';
import {Grid} from '@toast-ui/vue-grid';
import RestockContent from '@/components/product/restock/RestockContent.vue';
import PageContentBottom from '@/components/common/PageContentBottom.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import PageFormBtn from '@/components/board/common/PageFormBtn.vue';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import PageDateRangePicker from '@/components/board/common/PageDateRangePicker.vue';
import PageDateFilterBtns from '@/components/board/common/PageDateFilterBtns.vue';
import PageSizeData from '@/components/board/mixins/PageSizeData';
import { getProductsConfigurationsByAllMall, convertProductUri } from '@/utils/commonUtils';
import ItemTable from '@/components/common/ItemTable.vue';
import {ncpPopup} from '@/utils/ncp';
import RestockDetailDataMixin from '@/views/product/restock/RestockDetailDataMixin';
import {GetProductsRestockViewRequest, XhrErrorCode} from 'supporter';

const sendRequestType = {
  'ALL': null,
  'SEND': true,
  'NOT_YET_SEND': false
};

@Component({
  components: {
    RestockContent,
    PageContentBottom,
    PageTitle,
    PageFormBtn,
    PageFormSelect,
    PageDateRangePicker,
    PageDateFilterBtns,
    PageSizeData,
    Grid,
    ItemTable
  }
})
export default class RestockDetail extends Mixins(RestockDetailDataMixin, PageSizeData) {
  @Ref('restockGrid') restockGridRef: ItemTable;

  private displayRestockHelpFlag: boolean = false;
  private configAllMallUrl: {[propName: string]: string}[] = [];
  private isLastData: boolean = false;
  private restockNos: number[] = [];

  private params: GetProductsRestockViewRequest['params'] = {
    mallNo: 0,
    optionNo: 0,
    isSent: '',
    page: 1,
    size: 30
  };

  private async created(): Promise<void> {
    this.putRouterValueIntoParams();
    this.setConfigAllMallUrl();
    this.search(1, this.params.size);
  }

  private putRouterValueIntoParams() {
    const {mallNo, optionNo} = this.$route.query;
    this.params.mallNo = Number(mallNo);
    this.params.optionNo = Number(optionNo);
  }

  private async setConfigAllMallUrl(): Promise<void> {
    this.configAllMallUrl = (await getProductsConfigurationsByAllMall()).map(({mallNo, productDetailUrl}: any): any => {
      return {[mallNo]: productDetailUrl};
    });
  }

  private mounted() {
    $('body').on('click', '.js-btn-member-name', $.proxy(this.openMemberCrmPopup, this));
  }

  private beforeDestroy() {
    $('body').off('click', '.js-btn-member-name');
  }


  private openMemberCrmPopup(e) {
    const { memberNo } = e.target.dataset;
    ncpPopup(`/member/popup/crm/${memberNo}`, this.$t('MEMBER_LIST_INFORMATION2'), 1024, 800);
  }

  private get isSent(): string {
    return sendRequestType[this.sendType];
  }

  private async search(page = 1, size?: number) {
    try {
      this.params.isSent = this.isSent;
      this.params.page = page;

      if (size) {
        this.params.size = size;
      }

      this.restockGridInfo.props.options.pageOptions.perPage = size;

      // basicInfo, restockInfo
      const { data } = await this.$api.getProductsRestockView({params: this.params});
      const { basicInfo, restockInfo } = data;

      this.basicGridInfo.contents = this.addUrlToBasicInfo(basicInfo, this.configAllMallUrl);
      Object.assign(this.restockGridInfo, restockInfo);
      this.isLastData = false;
      const restockNos = restockInfo.contents.map((content) => content.restockNo)
      this.restockNos = restockNos;

    } catch(error) {
      if (XhrErrorCode.NOTFOUND_ERROR) {
        this.isLastData ? this.$router.push({name: 'Restock'}) : this.restockGridInfo.contents = [];
      }
    }
  }

  private addUrlToBasicInfo(basicInfo, urlList) {
    const mallNo = this.params.mallNo;
    const duplicateInfo = JSON.parse(JSON.stringify(basicInfo));
    duplicateInfo['url'] = convertProductUri(urlList.find(item => item[mallNo])[mallNo], duplicateInfo.productNo);

    if (duplicateInfo.optionType === null) {
      duplicateInfo['_attributes'] = {
        className: { row: ['deleted-item'] }
      };
    }

    return [duplicateInfo];
  }

  // 선택 삭제
  private async onDeleteCheckdUser(): Promise<void> {
    const checkedRows = this.restockGridRef.gridFunction('getCheckedRows');
    const restockNos = checkedRows.map(row => row.restockNo);

    if (!checkedRows.length) return alert(this.$t('PRODUCT_RESTOCK_ALERT_SELECT_ROW') as string);
    if (!confirm(this.$t('PRODUCT_RESTOCK_CONFIRM_RESTOCK_RESULT_DELETE') as string)) return;

    try {
      await this.$api.deleteProductsRestock({params: {restockNos}});
      this.isLastData = true;
      this.search(1, this.params.size);
    } catch(error) {
      console.error(error);
    }

  }

  // sms 발송
  private async sendSMS(): Promise<void> {
    try {
      const { data } = await this.$api.getNotificationsConfigurations({params: {mallNo: this.params.mallNo}});
      const { smsSendno, smsUsed } = data;
      if (!smsSendno || !smsUsed) return alert(this.$t('PRODUCT_RESTOCK_ALERT_SMS_SETTING'));

      const getData = this.restockGridRef.gridFunction('getData');
      const unSentMembers = getData.filter(row => row.isSent === false);
      if(!unSentMembers.length) return alert(this.$t('PRODUCT_RESTOCK_ALERT_EMPTY_UN_SENT_MEMBER'));

      if (!confirm(this.$t('PRODUCT_RESTOCK_CONFIRM_SMS_SEND') as string)) return;

      const unSentPhoneNumbers = unSentMembers.map(item => item.phone);
      const { mallName, productName, optionName, optionValue } = this.basicGridInfo.contents[0];
      ncpPopup(`${process.env.VUE_APP_PREMIUM_ADMIN_URL}/popup/sms-send?mallNo=${this.params.mallNo}&mallName=${encodeURIComponent(mallName)}&recipients=${unSentPhoneNumbers}&type=RESTOCK&productName=${encodeURIComponent(productName)}&optionName=${encodeURIComponent(optionName)}&optionValue=${encodeURIComponent(optionValue)}&restockNos=${this.restockNos}`, 'SmsSendPopup', 1024, 750);

    } catch(error) {
      console.error(error);
    }
  }

  private reset(): void {
    this.sendType = 'ALL';
  }
}
